import {
  SECTIONS_LIST,
  SECTIONS_LIST_SUCCESS,
  SECTIONS_LIST_ERROR,
  SECTIONS_NEW,
  SECTIONS_NEW_SUCCESS,
  SECTIONS_NEW_ERROR,
  SECTIONS_EDIT,
  SECTIONS_DELETE,
  SECTIONS_DELETE_SUCCESS,
  SECTIONS_DELETE_ERROR,
  SECTIONS_COMPANIES_LIST,
  SECTIONS_COMPANIES_LIST_SUCCESS,
  SECTIONS_COMPANIES_LIST_ERROR,
} from "./actionTypes"


export const sectionsList = data => ({
  type: SECTIONS_LIST,
  payload: data
});

export const sectionsListSuccess = data => ({
  type: SECTIONS_LIST_SUCCESS,
  payload: {data}
});

export const sectionsListError = error => ({
  type: SECTIONS_LIST_ERROR,
  payload: error,
});

export const sectionsNew = data => ({
  type: SECTIONS_NEW,
  payload: data
});

export const sectionsNewSuccess = data => ({
  type: SECTIONS_NEW_SUCCESS,
  payload: {data}
});

export const sectionsNewError = error => ({
  type: SECTIONS_NEW_ERROR,
  payload: error,
});

export const sectionsEdit = data => ({
  type: SECTIONS_EDIT,
  payload: data
});

export const sectionsDelete = data => ({
  type: SECTIONS_DELETE,
  payload: data
});

export const sectionsDeleteSuccess = data => ({
  type: SECTIONS_DELETE_SUCCESS,
  payload: {data}
});

export const sectionsDeleteError = error => ({
  type: SECTIONS_DELETE_ERROR,
  payload: error,
});

export const sectionsCompaniesList = data => ({
  type: SECTIONS_COMPANIES_LIST,
  payload: data
});

export const sectionsCompaniesListSuccess = data => ({
  type: SECTIONS_COMPANIES_LIST_SUCCESS,
  payload: {data}
});

export const sectionsCompaniesListError = error => ({
  type: SECTIONS_COMPANIES_LIST_ERROR,
  payload: error,
});